import { useAblyTypedPubSub } from '../use-ably'
import { Evidence } from '@db8/shared'
import { useHall } from '@/contexts/HallProvider'
import { useAxios } from '@/contexts/AxiosProvider'

export const useEvidencePubSub = (
  setEvidenceList: (updater: (prev: Evidence[]) => Evidence[]) => void,
) => {
  const { hall } = useHall()

  const { publish, isFetching } = useAblyTypedPubSub<Evidence | Evidence[]>(
    'evidence',
    ({ data }) => {
      setEvidenceList((prev) => {
        if (Array.isArray(data)) return data

        if (!data?.id) return prev

        if ((data as any).toDelete) return prev.filter((e) => e.id !== data.id)

        const exists = prev.some((e) => e.id === data.id)

        return exists ? prev.map((e) => (e.id === data.id ? data : e)) : [...prev, data]
      })
    },
    hall?.id
      ? {
          url: `/evidence?hallId=${hall.id}`,
        }
      : undefined,
  )

  const broadcastEvidence = (e: Evidence) => {
    if (hall?.id) publish(e)
  }

  return { broadcastEvidence, isFetching }
}
